module.exports = __webpack_public_path__ + "img/cards1_front76.ccd4adf1.png";